import dynamic from 'next/dynamic'

// always dynamically import popover!
const Popover = dynamic(/* #__LOADABLE__ */() => import('./Popover')) // maybe could be better with SSR false

export default Popover